export const OPEN_CHAT_WINDOW = 'OPEN_CHAT_WINDOW';
